import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theme';
import SectionWrapper from '../../../Layout/SectionWrapper';

const ShopTheLookWrapper = styled(SectionWrapper)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 80px 32px 80px 32px;
`;

const ContentWrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  max-width: 1200px;
  justify-content: space-between;
  margin: 0 auto;
  gap: 24px;

  ${theme.below.md} {
    flex-direction: column;
    display: flex;
    max-width: 682px;
    align-content: flex-start;
    gap: 0;
  }

  ${theme.below.sm} {
    flex-direction: column;
    display: flex;
    max-width: 343px;
    align-content: flex-start;
  }
`;

const LeftColumn = styled('div')`
  flex-basis: 35%;
  flex-shrink: 1;
  position: sticky;
  top: 220px;
  align-items: flex-start;

  ${theme.below.md} {
    position: relative;
    top: 0;
    gap: 0;
    margin-bottom: 30px;
    flex-basis: 60%;
    display: flex;
    flex-direction: column;
  }
`;

const RightColumn = styled('div')`
  flex-basis: 60%;
  display: flex;
  flex-direction: column;
  gap: 112px;

  ${theme.below.md} {
    width: 100%;
  }
`;

const Title = styled('div')`
  font-family: ${theme.fonts.primary};
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Description = styled('p')`
  margin-bottom: 16px;
  font-size: 16px;
`;

const ShopLookWrapper = styled('div')`
  display: grid;
  grid-template-columns: 595px 79px;
  gap: 8px;

  ${theme.below.sm} {
    display: flex;
    flex-direction: column;
  }
`;

const InspirationImage = styled('img')`
  height: 635px;
  width: 595px;
  object-fit: cover;
  gap: 8px;

  ${theme.below.md} {
    width: 100%;
    height: auto;
    aspect-ratio: 595 / 635;
  }

  ${theme.below.sm} {
    max-width: 100%;
    height: auto;
  }
`;

const ClickableImages = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 79px;

  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  ${theme.below.sm} {
    flex-direction: row;
    max-width: 343px;
  }
`;

const ProductImage = styled('img')`
  width: 79px;
  height: 119px;
  object-fit: cover;

  ${theme.below.sm} {
    max-width: 109px;
    max-height: 169px;
    display: inline-block;
  }
`;

const TextWrapper = styled('div')`
  font-size: 14px;
  max-width: 342px;
  margin-top: 6px;
`;

const ShopButton = styled('div')`
  display: flex;
  justify-content: center;
  width: 150px;
  text-decoration: none;
  white-space: nowrap;
  padding: 10px 20px;
  background-color: transparent;
  color: black;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.02em;
  border: 1px solid black;
    :hover {
      background-color: black;
      color: white;
    }
  }
`;

const BodyTextHeading = styled('p')`
  font-weight: 600;
`;

const ShopTheLook = ({ title, description, button, blocks }) => {
  return (
    <ShopTheLookWrapper>
      <ContentWrapper>
        <LeftColumn>
          <TextWrapper>
            {title && <Title>{title}</Title>}
            {description && <Description>{description}</Description>}
          </TextWrapper>
          {button && button[0] && (
            <a
              href={button[0].link.cached_url}
              style={{ display: 'inline-block', textDecoration: 'none' }}
            >
              <ShopButton>{button[0]?.label || 'Learn More'}</ShopButton>
            </a>
          )}
        </LeftColumn>

        <RightColumn>
          {blocks.map((block, index) => (
            <ShopLookWrapper key={index}>
              <InspirationImage
                src={block.image?.filename || 'fallback-image.jpg'}
                alt={block.image?.alt || 'No image available'}
              />
              <ClickableImages>
                {block.products?.map(product => {
                  const productLink = product.link?.cached_url || '#';
                  return (
                    <a href={productLink} rel="noopener noreferrer">
                      <ProductImage
                        src={product.media?.filename || 'fallback-product.jpg'}
                        alt={product.media?.alt || 'Product image'}
                      />
                    </a>
                  );
                })}
              </ClickableImages>
              <TextWrapper>
                {block.description?.[0]?.body_text_heading && (
                  <BodyTextHeading>
                    {block.description[0].body_text_heading}
                  </BodyTextHeading>
                )}
                {block.description?.[0]?.body_text && (
                  <p>{block.description[0].body_text}</p>
                )}
              </TextWrapper>
            </ShopLookWrapper>
          ))}
        </RightColumn>
      </ContentWrapper>
    </ShopTheLookWrapper>
  );
};

export default ShopTheLook;
